import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryCard = ({ category, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="group bg-card border border-border rounded-lg p-6 hover:shadow-elevation-md hover:border-primary/50 transition-smooth text-left"
    >
      <div className={`w-12 h-12 ${category?.bgColor} rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-smooth`}>
        <Icon name={category?.icon} size={24} className={category?.color} />
      </div>
      <h3 className="text-lg font-heading font-semibold text-foreground mb-2 group-hover:text-primary transition-smooth">
        {category?.title}
      </h3>
      <p className="text-sm text-muted-foreground mb-3">
        {category?.description}
      </p>
      <div className="flex items-center justify-between">
        <span className="text-xs text-muted-foreground">
          {category?.articleCount} articles
        </span>
        <Icon name="ArrowRight" size={16} className="text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-smooth" />
      </div>
    </button>
  );
};

export default CategoryCard;